import { render } from "./AnalysisPage.vue?vue&type=template&id=b6af4964&scoped=true"
import script from "./AnalysisPage.vue?vue&type=script&lang=js"
export * from "./AnalysisPage.vue?vue&type=script&lang=js"

import "./AnalysisPage.vue?vue&type=style&index=0&id=b6af4964&scoped=true&lang=scss"

import exportComponent from "/lab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6af4964"]])

export default __exports__